/**
 * @deprecated Import from `layouts/theme/designSystem` instead.
 * Kept for gradual migration after the design-system refactor.
 */
export {
  greenColors,
  neutral,
  orangeColors,
  primary,
  warningColor,
  warningColorDark,
  warningColorLight,
} from './designSystem';

import {greenColors, orangeColors} from './designSystem';

export const empionOrange = orangeColors;
export const empionGreen = greenColors;
